import "./Main.css";
import React from "react";
import Slider from "./Slider";
import { t } from "i18next";
import "./Slider.css";

export default function Partners() {
  return (
    <section className="skyua-main-section skyua-partners-section">
      <div className="skyua-main-container">
        <div className="skyua-main-heading">
          <span className="skyua-main-eyebrow">{t("partners title")}</span>
          <h2>
            {t("home partners heading") !== "home partners heading"
              ? t("home partners heading")
              : "Разом із тими, хто допомагає діяти швидше"}
          </h2>
        </div>

        <Slider />
      </div>
    </section>
  );
}
